import classNames from "classnames";

export type HotkeyIconProps = {
  /** A string representing the hotkey (e.g., "⌘", "K", "Shift") */
  hotkey: string;
  /** The variant of the hotkey icon. Default is `primary`. */
  variant?: "primary" | "secondary";
  /** The size of the hotkey icon. Default is `md`. */
  size?: "sm" | "md";
};

/**
 * `HotkeyIcon` is a small, non-interactive UI component for displaying
 * a hotkey inside a styled box that resembles the key of a keyboard.
 */
function HotkeyIcon({
  hotkey,
  variant = "primary",
  size = "md",
}: HotkeyIconProps) {
  return (
    <div
      className={classNames(
        "flex items-center justify-center border rounded-md",
        {
          "bg-bg-base border-border-base text-fg-muted": variant === "primary",
          "bg-transparent text-accent-emphasis border-accent-emphasis":
            variant === "secondary",
        },
        {
          "h-6 min-w-6 sm-bold border-b-3": size === "md",
          "h-5 min-w-5 tiny-bold border-b-2": size === "sm",
        }
      )}
      role="img"
      aria-label={`Key: ${hotkey}`}
    >
      {hotkey}
    </div>
  );
}

export default HotkeyIcon;
